<template>
  <div v-if="guidanceInfo.guidanceWechat && qrUrl">
    <!-- pc气泡型qrcode -->
    <div v-if="!isMobile" class="icon-guidance-wechat"
      @mouseenter="showQRCode($event, true)"
      @mouseleave="showQRCode($event, false)"
      >
      <img src="./assets/qrcode.svg" />
    </div>
    <div ref="qrcodePopPC"
      class="guidance-wechat"
      :class="isShow? 'guidance-wechat-show animate__animated animate__fadeIn' : ''"
      :style="pos">
      <img class="qrcode" :src="qrUrl" />
      <div class="comment">{{ comment }}</div>
      <div class="outer"></div>
      <div class="inner"></div>
    </div>

    <!-- h5页弹框型qrcode -->
    <div v-if="isMobile" class="icon-guidance-wechat"
      @click.stop="showQRCodeH5(true)"
      >
      <img src="./assets/qrcode.svg" />
    </div>
    <div ref="qrcodePopH5"
      class="guidance-wechat-h5"
      :class="isShowH5? 'guidance-wechat-h5-show animate__animated animate__fadeIn' : ''"
      @click="showQRCodeH5(false)"
      >
      <div class="content" @click.stop>
        <div class="title">{{ comment }}</div>
        <img class="qrcode" :src="qrUrl">
        <div class="cmd">长按二维码保存图片</div>
        <div class="tip">获取更多企业资料和个性化服务</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    guidanceInfo: {
      type: Object,
    },
  },
  data() {
    return {
      isShow: false,
      pos: '',
      isShowH5: false,
    };
  },

  computed: {
    qrUrl() {
      return this.guidanceInfo?.guidanceData?.qrUrl || '';
    },

    isMobile() {
      return !this.$platform.pc;
    },

    comment() {
      const gType = this.guidanceInfo?.guidanceData?.type;
      let cmt = '';
      switch (gType) {
        case '企业公众号':
          cmt = '关注公众号';
          break;
        case '企业小程序':
          cmt = '打开小程序';
          break;
        case '企业群':
          cmt = '加入企业群';
          break;
        default:
      }
      cmt = `扫码${cmt}`;

      if (this.isMobile) {
        if (gType === '企业群') {
          cmt  = `QQ扫描二维码，${cmt}`;
        } else {
          cmt  = `微信扫描二维码，${cmt}`;
        }
      }

      return cmt;
    },
  },

  methods: {
    /**
     * 显示引流二维码
     */
    showQRCode(e, isShow) {
      this.isShow = isShow;
      const qrimg = this.$refs.qrcodePopPC;
      document.body.append(qrimg);

      // 计算二维码显示的位置
      const qrPopSize = 96;
      const commentHeight = 12;
      const arrowHeight = 10;

      if (isShow) {
        const { x, y } = this.getPos(this.$el);

        this.pos = `
          left: ${x - qrPopSize / 2}px;
          top: ${y - qrPopSize - commentHeight - arrowHeight}px;
        `;
      }
    },

    /**
     * 查看H5二维码
     */
    showQRCodeH5(isShow) {
      if (!this.isMobile) {
        return;
      }

      this.isShowH5 = isShow;
      const qrimg = this.$refs.qrcodePopH5;
      document.body.append(qrimg);
    },

    /**
     * 获得dom节点上二维码箭头指向的位置
     */
    getPos(el) {
      const rect = el.getBoundingClientRect();
      return { x: rect.left + window.pageXOffset + rect.width / 2, y: rect.top + window.pageYOffset };
    },
  },
};
</script>

<style lang="less" scoped>
.icon-guidance-wechat{
  width: 12px;
  height: 12px;
  overflow: hidden;
  padding: 0 4px;
  // 添加定位 解决在safari中由于使用filter: drop-shadow()导致引流icon不展示的问题
  position: relative;
  >img{
    display: block;
    width: 100%;
    height: 100%;
    filter: drop-shadow(@primary -24px 0 0);
    transform: translateX(24px);
  }
}

// 解决在ios中由于使用filter: drop-shadow()导致引流icon不展示的问题
.platform-iOS .icon-guidance-wechat {
  >img {
    filter: drop-shadow(@primary -12.1px -12.1px 0);
    transform: translate3d(11.9px, 11.9px, 0);
  }
}

.guidance-wechat{
  animation-duration: 0.3s;
  position: absolute;
  display: none;
  box-shadow: 0 1px 12px 0 rgba(30, 36, 49, 0.15);
  background-color: #fff;
  border-radius: 2px;
  z-index: 600;
  padding: 6px;
  font-size: 12px;

  &-show{
    display: block;
  }

  .qrcode{
    width: 84px;
    height: 84px;
    display: block;
  }

  .comment{
    font-size: 12px;
    line-height: 12px;
    text-align: center;
  }

  .outer, .inner{
    position: absolute;
    height: 0px;
    width: 0px;
    border-width: 8px 5px 0px;
    border-style: solid;
    border-image: initial;
    transform-origin: right center;
    transform: scale(1.3, 1);
    top: 108px;
    left: 45px;
  }
  .outer{
    border-color: rgb(47, 51, 59) transparent transparent;
  }
  .inner{
    border-color: rgb(255, 255, 255) transparent transparent;
  }
}


// H5qrcode
.guidance-wechat-h5{
  animation-duration: 0.3s;
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  padding-top: env(safe-area-inset-top);
  height: 100%;
  width: 100%;
  z-index: 101;
  background: rgba(0,0,0,0.5);

  &-show{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content{
    width: 300px;
    background: #fff;
    border-radius: 8px;
    text-align: center;
    font-size: 18px;
    padding: 30px 0;
  }

  .qrcode{
    display: block;
    margin: 20px auto;
    width: 192px;
    height: 192px;
  }

  .cmd {
    font-size: 17px;
  }

  .tip {
    font-size: 14px;
    margin-top: 6px;
    color: #78849e;
  }
}
</style>
